import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["toggleicon"]

  toggle() {
      // Toggle visibility (replaced stimulus-reveal functionality)
      const element = this.element
      const isHidden = element.style.display === 'none' || element.classList.contains('d-none')
      if (isHidden) {
          element.style.display = ''
          element.classList.remove('d-none')
      } else {
          element.style.display = 'none'
          element.classList.add('d-none')
      }
      
      this.toggleiconTarget.classList.toggle('bi-chevron-right');
      this.toggleiconTarget.classList.toggle('bi-chevron-left')
  }
}